var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.toggle}},[_c('v-icon',[_vm._v(_vm._s(_vm.isDark ? _vm.mdiWeatherSunny : _vm.mdiWeatherNight))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }